import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { DualColumnDropdown, SingleColumnDropdown } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { PrescriptionValueUtils, isNumber } from '@grandvisionhq/utils';
import { isPrescriptionValue } from '../../../../state/types.js';
import { usePrescriptionFormInput } from '../../context/PrescriptionFormInputContext.js';

const PLACEHOLDER = '---';
const getOptions = (values, prescriptionAttribute)=>{
    const formatter = PrescriptionValueUtils.getFormatter(prescriptionAttribute);
    return Array.from(values).reduce((acc, value)=>{
        const formattedValue = formatter(value);
        if (formattedValue) {
            return swcHelpers.objectSpread({}, acc, {
                [formattedValue]: value
            });
        } else {
            console.error(`Error formatting prescription value ${value} for attribute: ${prescriptionAttribute}`);
            return acc;
        }
    }, {});
};
const PrescriptionFormInputSelect = ()=>{
    const { name , selectId , selectName , isValid , isFirstItem , isLastItem , values , value: value1 , onChange , required , side ,  } = usePrescriptionFormInput();
    const { getLabel  } = useIntl();
    const options = React.useMemo(()=>getOptions(values, name)
    , [
        values,
        name
    ]);
    const hasNegativeValues = React.useMemo(()=>Object.values(options).some((value)=>value < 0
        )
    , [
        options
    ]);
    var ref;
    const formattedValue = (ref = PrescriptionValueUtils.formatPrescriptionValue(name, value1)) !== null && ref !== void 0 ? ref : '';
    const isInvalid = isValid === false;
    const selectedValue = React.useMemo(()=>isPrescriptionValue(value1) && values.has(value1) ? formattedValue : undefined
    , [
        values,
        value1,
        formattedValue
    ]);
    const fieldOptions = React.useMemo(()=>{
        // add neutral option for resetting the field
        if (!required) {
            options[PLACEHOLDER] = PLACEHOLDER;
        }
        return options;
    }, [
        options,
        required
    ]);
    const handleChange = React.useCallback((newValue)=>{
        if (isNumber(newValue)) {
            onChange(name, newValue);
        } else if (newValue === PLACEHOLDER) {
            onChange(name, undefined);
        }
    }, [
        onChange,
        name
    ]);
    if (hasNegativeValues) {
        return /*#__PURE__*/ React.createElement(DualColumnDropdown, {
            className: classnames('prescription-form-input-select', {
                'prescription-form-input-select--first': isFirstItem,
                'prescription-form-input-select--last': isLastItem
            }),
            label: `${getLabel(`products.glasses.prescription.${name}`)} ${getLabel(`products.glasses.${side}Eye`)}`,
            options: fieldOptions,
            selectedValue: selectedValue,
            onChange: handleChange,
            isInvalid: isInvalid,
            isRequired: required,
            "data-t": selectName,
            id: selectId
        });
    }
    return /*#__PURE__*/ React.createElement(SingleColumnDropdown, {
        className: classnames('prescription-form-input-select', {
            'prescription-form-input-select--first': isFirstItem,
            'prescription-form-input-select--last': isLastItem
        }),
        isInvalid: isInvalid,
        isRequired: required,
        selectedValue: selectedValue,
        options: fieldOptions,
        id: selectId,
        onChange: handleChange,
        label: `${getLabel(`products.glasses.prescription.${name}`)} ${getLabel(`products.glasses.${side}Eye`)}`,
        "data-t": selectName
    });
};

export { PrescriptionFormInputSelect };
//# sourceMappingURL=PrescriptionFormInputSelect.js.map
